export const visitType = [ 
    { id: 'payment', name: 'Платный' },
    { id: 'withoutPayment', name: 'Бесплатный' }
];